import styles from './symbol-bar.module.css';

const SymbolsBar = ({
    value,
    field,
    cursorPosition,
    onInsert,
    symbols = ['•', '→', '➔', '✔', '✦', '★', '🎯', '🚫', '⛔', '❎', '❌', '✗', '✘', '📌', '💼', '📍', '💡', '🚀', '🛠️', '🗘️', '🎓', '⏳', '▶', '●']
}) => {

    const insertSymbol = (symbol) => {
        const start = cursorPosition || value.length;
        const end = cursorPosition || value.length;
        const newValue = value.slice(0, start) + symbol + value.slice(end);
        const newCursor = start + symbol.length;
        onInsert(field, newValue, newCursor);
    };

    return (
        <div className={styles.symbolsBarContainer}>
            {symbols.map((symbol, i) => (
                <button
                    key={i}
                    type="button"
                    className={styles.symbolButton}
                    onMouseDown={(e) => {
                        e.preventDefault();
                        insertSymbol(symbol);
                    }}
                >
                    {symbol}
                </button>
            ))}
        </div>
    );
};

export default SymbolsBar;
